import axios, { type AxiosRequestConfig } from "axios"
import { user, contract, callout, config as configStore } from "../stores/index"
import { get } from "svelte/store"

// INTERCEPTING API ERRORS AND SENDING IT TO CALLOUT STORE
axios.interceptors.response.use(
  (r) => {
    return r
  },
  (e) => {
    if (e?.response?.status === 403) {
      const errorMessage = e?.response?.data?.message ? `Error: ${e.response.data.message}` : e
      callout.set({ msg: errorMessage, status: "error", timeout: true })
      throw e
    } else if (e?.config?.method === "get" && (e?.response?.status === 404 || e?.response?.status === 400)) {
      const errorMessage = e?.response?.data?.message ? `Error: ${e.response.data.message}` : e
      callout.set({ msg: errorMessage, status: "error", timeout: true })
      throw e
    } else {
      const errorMessage = e?.response?.data?.message ? `Error: ${e.response.data.message}` : e
      callout.set({ msg: errorMessage, status: "error", timeout: true })
      throw e
    }
  },
)

class API {
  private _url: string = ""
  private contractid: string | null

  public get url() {
    return this._url
  }

  constructor() {
    this.contractid = null
    contract.subscribe((contract) => {
      this.contractid = contract ? contract.id : null
    })
  }

  init(apiurl: string) {
    this._url = apiurl
  }

  async getToken() {
    let token
    user.subscribe((user) => {
      token = user ? user.token : null
    })
    return ` ${token.type || ""} ${token.token}`.trim()
  }

  async request<T>(method: string, url: string, data?: any, config?: AxiosRequestConfig | any) {
    const token = await this.getToken()
    const appConfig = get(configStore)
    const dev = this.url?.includes("localhost") || appConfig.isStandalone
      ? { "gl-user-id": appConfig.user?.data.id, "gl-policies": appConfig.user?.policies?.map(p => p.id) || ""}
      : {}
    const response = await axios.request<T>({
      method,
      baseURL: this.url,
      url,
      data,
      ...config,
      headers: {
        Authorization: token,
        "gl-contract-id": config?.contract === "global" ? null : this.contractid,
        ...(config?.headers || {}),
        ...dev,
      },
    })
    return response.data
  }

  async get<T>(url: string, config: AxiosRequestConfig | any = {}) {
    return this.request<T>("get", url, null, config)
  }

  async post<T>(url: string, data: any, config: AxiosRequestConfig | any = {}) {
    return this.request<T>("post", url, data, config)
  }

  async put<T>(url: string, data: any, config: AxiosRequestConfig | any = {}) {
    return this.request<T>("put", url, data, config )
  }

  async patch<T>(url: string, data: any, config: AxiosRequestConfig | any = {}) {
    return this.request<T>("patch", url, data, config )
  }

  async delete<T>(url: string) {
    return this.request<T>("delete", url )
  }
}

export default API
